import store from '@/state/store';
import { getThumbnail } from '@/api/project';
import { handleError } from '@/actions/common';
import projectSlice from '@/state/project.slice';
import { RequestStatus } from '@/contracts';

export default async function (code: string, hash: string): Promise<void> {

  const state = store.getState();
  if (state.projects.thumbnails[code]?.status === RequestStatus.BUSY) {
    return;
  }

  try {
    store.dispatch(projectSlice.actions.thumbnailBusy(code));
    const source = await getThumbnail(hash);
    store.dispatch(projectSlice.actions.thumbnailIdle({
      projectId: code,
      source
    }));
  } catch (error) {
    store.dispatch(projectSlice.actions.thumbnailError(code));
    handleError(error);
  }
};